type Pillar = {
  title: string;
  description: string;
};

type PillarsSectionProps = {
  pillars: Pillar[];
};

export function PillarsSection({ pillars }: PillarsSectionProps) {
  return (
    <section className="bg-slate-950 py-24" aria-labelledby="pillars-heading">
      <div className="mx-auto max-w-6xl px-6">
        <div className="max-w-3xl">
          <h2
            id="pillars-heading"
            className="text-3xl font-semibold text-white sm:text-4xl"
          >
            What AVUX does to deliver measurable change
          </h2>
          <p className="mt-4 text-slate-300">
            End-to-end expertise across strategy, AI experience design, and operational-scale delivery.
          </p>
        </div>
        <div className="mt-12 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {pillars.map((pillar) => (
            <article
              key={pillar.title}
              className="rounded-3xl border border-white/10 bg-gradient-to-b from-white/10 via-transparent to-white/5 p-8 text-slate-100 shadow-[0_20px_45px_-25px_rgba(15,23,42,0.7)] transition hover:border-emerald-300/40 hover:shadow-[0_25px_60px_-20px_rgba(45,212,191,0.35)]"
            >
              <h3 className="text-xl font-semibold text-white">{pillar.title}</h3>
              <p className="mt-4 text-sm text-slate-300">{pillar.description}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
